





























import { computed, defineComponent,  ref,  useContext, useRoute, watch } from '@nuxtjs/composition-api'
import useLoader from '~/composables/useLoader';
import useProductPage from '~/composables/useProductPage'
import { getFirstPriceLabel, getSecondPriceLabel, getFinalPriceLabel, getShippingCost } from '~/utils/helpers/product';
import AddToCart from '~/components/AddToCart.vue';
import { ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS } from '~/utils/constants/product';
import { trackBuyFromProductPage } from '~/helpers/trackings/product';
import { SKU_SEPARATOR } from '~/utils/constants/code';
export default defineComponent({
    components:{
        AddToCart
    },
    setup() {
        const { product, addToCartConfigs, setAddToCartConfigs, paymentFrequencyChoosen, setOffset, modulesKeys, finalPrice,  addModule, bundleTipoConsegna,checkForceDisableAddToCart} = useProductPage();
        const {app : { i18n }, $fc} = useContext();
        const { isLoading, setIsLoading} = useLoader();
        const route = useRoute();
        setIsLoading(true)

        if(product.value.customizable_options){
            const data_uscita = product.value.customizable_options.find(el => el.title == 'data_uscita');
            if (data_uscita && route.value.query.copyDate) setAddToCartConfigs({...addToCartConfigs.value, [data_uscita.option_id] : route.value.query.copyDate })
        }

        //@ts-ignore
        const getDiscountedShipping = addToCartConfigs.value?.['shippingType'] == 'Edicola' ?  product.value?.discountedPriceEdicola ?? 0 : product.value?.discountedPricePosta ?? 0

        //If shippingCost exists add it to the product prices
        const firstPriceLabel = computed(()=>getFirstPriceLabel(product.value, paymentFrequencyChoosen.value, i18n, $fc, addToCartConfigs.value?.['shippingCost'] ?? 0 , getDiscountedShipping));
        /** SECOND LABEL Active if trial or promotion */
        const secondPriceLabel = computed(()=>getSecondPriceLabel(product.value, paymentFrequencyChoosen.value, i18n, $fc, addToCartConfigs.value?.['shippingCost'] ?? 0, getDiscountedShipping));
        /** Final price label overrides first and second price labels for configurable products */
        const finalPriceLabel = computed(()=> finalPrice.value && getFinalPriceLabel(i18n, $fc, finalPrice.value, product, paymentFrequencyChoosen.value,addToCartConfigs.value?.['shippingCost'] ?? 0, getDiscountedShipping))
        /** ugly but tailwind sticky doesn't work on mobile/tablet @TODO check */
        watch(isLoading, ()=>{
            isLoading && document ? setTimeout(()=>{
                setOffset(document.querySelector('.product-page-sticky-bottom')['offsetHeight']+150 )
            }, 0): null;
        })
        setIsLoading(false)
        /**
         * Don't check tipo_abbonamento because it's always pre-compiled (high payment frequency as default )
         */
        
        const forceDisableAddToCart = computed(()=>checkForceDisableAddToCart(product.value));
        watch(addToCartConfigs,()=>checkForceDisableAddToCart(product.value))
        const selectedModulesSkus = computed(()=>{
            return modulesKeys.value.map(el=>el.split(SKU_SEPARATOR)[1])
        });
        if(product.value.requiredModules.length>0){
            product.value.requiredModules.forEach(module => addModule(module.product))
        }
        return {
            product,
            addToCartConfigs,
            firstPriceLabel,
            secondPriceLabel,
            forceDisableAddToCart,
            finalPriceLabel,
            trackBuyFromProductPage,
            paymentFrequencyChoosen,
            selectedModulesSkus,
            ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS,
            bundleTipoConsegna
        }
    },
})
